module.exports = __webpack_public_path__ + "img/pha-logo-small.c50d0cb3.png";